import { render, staticRenderFns } from "./UserGenerateImage.vue?vue&type=template&id=f8affa96&scoped=true&"
import script from "./UserGenerateImage.vue?vue&type=script&lang=js&"
export * from "./UserGenerateImage.vue?vue&type=script&lang=js&"
import style0 from "./UserGenerateImage.vue?vue&type=style&index=0&id=f8affa96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8affa96",
  null
  
)

export default component.exports